import { selectActiveJobs, selectClosedJobs, selectFetchingPostedJobs } from '../../../../../store/workspace/selectors';
import { resetExamStatistics } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { PostedJob } from '../../../../../store/workspace/types';
import JobCard from '../../../../../components/JobCard';
import { useEffect, useState } from 'react';
import JobsSkeleton from './JobsSkeleton';
import styles from './style.module.scss';

type Tab = 'active' | 'closed';

function Jobs() {
    const dispatch = useDispatch();
    const [tab, setTab] = useState<Tab>('active');
    const fetchingJobs = useSelector(selectFetchingPostedJobs);
    const activeJobs = useSelector(selectActiveJobs);
    const closedJobs = useSelector(selectClosedJobs);

    useEffect(() => {
        dispatch(resetExamStatistics());
    }, [dispatch]);

    const tabs: { id: Tab; title: string; jobs: PostedJob[]; emptyText: string }[] = [
        { id: 'active', title: 'Active jobs', jobs: activeJobs, emptyText: 'No active jobs.' },
        { id: 'closed', title: 'Closed jobs', jobs: closedJobs, emptyText: 'No closed jobs.' },
    ];

    const currentTab = tabs.find(item => item.id === tab) ?? tabs[0];
    const showSkeleton = fetchingJobs && activeJobs.length === 0 && closedJobs.length === 0;

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.title}>History</span>

            <div className={styles.tabs}>
                {tabs.map(item => <div
                    key={item.id}
                    className={styles.tabs_item}
                    onClick={() => setTab(item.id)}
                    data-is-active={tab === item.id}
                >
                    <span>{item.title} ({item.jobs.length})</span>
                </div>)}
            </div>

            <div className={styles.jobs}>
                {showSkeleton && <JobsSkeleton />}

                {!showSkeleton && (currentTab.jobs.length > 0
                    ? currentTab.jobs.map(job => <JobCard key={job.id} detail={job} />)
                    : <div className={styles.empty}><span>{currentTab.emptyText}</span></div>)}
            </div>
        </MotionWrapper>
    );
};

export default Jobs;
